export const getMarkedState = (comment, markedState) => {
    if (markedState.type === 'IDLE') {
        return { isMarked: !!comment.isMarked, pending: false };
    }
    return { isMarked: markedState.action === 'ADD', pending: true };
};
//# sourceMappingURL=mark-selectors.js.map